import { Controller } from "@hotwired/stimulus";
import { useTransition } from "stimulus-use";
import { post } from '@rails/request.js';

export default class extends Controller {
  static values = { data: Object };
  timeoutId: number;
  declare readonly hasDataValue: boolean;
  declare readonly dataValue: { duration: number; id?: number };
  declare readonly enter: () => void;
  declare readonly leave: () => void;

  connect() {
    console.log('toast connect');
    useTransition(this as any, {
      element: this.element,
      enterActive: 'transform ease-out duration-500 transition',
      enterFrom: 'translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2',
      enterTo: 'translate-y-0 opacity-100 sm:translate-x-0',
      leaveActive: 'transition transform ease-in duration-100',
      leaveFrom: 'opacity-100',
      leaveTo: 'opacity-0 -translate-y-2',
      hiddenClass: 'hidden'
    });
    this.enter();
    this.initTimeout();
    this.maybeChangeBackgroundColor();
  }

  disconnect() {
    console.log('toast disconnect');
    if (this.timeoutId) clearTimeout(this.timeoutId);
  }

  animationEnd = e => {
    console.log('animationEnd', e);
  }

  get backgroundColor() {
    return Array.from(this.element.classList).find(c => c.startsWith('bg-'));
  }

  get modalOpen(): boolean {
    const backdrop = document.querySelector('.modal-backdrop');
    return !!backdrop && !backdrop.classList.contains('hidden');
  }

  maybeChangeBackgroundColor = () => {
    if (!this.modalOpen) return;
    const newBgColor = this.backgroundColor?.split('/')?.[0];
    if (!!newBgColor) this.element.classList.replace(this.backgroundColor, newBgColor);
  }

  close = () => {
    console.log('close')
    this.leave();
    setTimeout(() => {
      console.log('tick', this.element.classList.contains('hidden'));
      if (this.element.classList.contains('hidden')) {
        this.element.remove();
      }
    }, 500);
  }

  clear = async e => {

  }

  initTimeout = () => {
    if (!this.hasDataValue) return;
    const { duration } = this.dataValue || {}
    if (!duration) return
    this.timeoutId = setTimeout(() => {
      this.close();
    }, duration);
  }
}
